export default "__VITE_ASSET__CrYmgAOv__"